import applicationFormService from '../../services/applicationForm.service';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';

const removeVirtualCard = async (applicationId: number) => {
  try {
    const { data } = await applicationFormService.removeVirtualCard({ applicationId });

    return data?.removeVirtualCard;
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default removeVirtualCard;
